import { createTheme } from '@mui/material/styles';
import button from './button';
import checkbox from './checkbox';
import tablePagination from './tablePagination';
import pagination from './pagination';
import breadrumbs from './breadcrumbs';
import fields from './fields';
import alert from './alert';
import typography from './typography';
import baseStyles from './baseStyles';

import COLORS from './colors';

const theme = createTheme({
  palette: {
    primary: {
      main: COLORS.accent
    },
    secondary: {
      main: COLORS.green,
      dark: COLORS.gray
    },
    error: {
      main: COLORS.red
    },
    warning: {
      main: COLORS.orange
    },
    success: {
      main: COLORS.green
    },
    text: {
      primary: COLORS.textColor,
      secondary: COLORS.textSecondColor
    },
  },
  typography: typography,
  components: {
    MuiPagination: pagination,
    MuiTablePagination: tablePagination,
    MuiCheckbox: checkbox,
    MuiBreadcrumbs: breadrumbs,
    MuiFormControl: fields,
    MuiButton: button,
    MuiAlert: alert,
    MuiBackdrop: {
      styleOverrides: {
        root: {
          backgroundColor: 'rgba(25, 42, 62, .2)',
        }
      }
    },
    MuiCssBaseline: baseStyles,
  },
  mixins: {
    toolbar: {
      minHeight: 70
    }
  }
});

export default theme;
